import React, { useState, useEffect } from 'react'
import { Box, Button, Divider } from '@mui/material'
import { Check as CheckIcon, Clear as ClearIcon } from '@mui/icons-material'

import { useDispatch, useSelector } from 'react-redux'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useStyles } from '../CaseWorklist/Pathologist/inboxStyles'
import SuccessSnackBar from './SuccesSnackBar'
import { RootState } from '../../reducers'

import { runLoadBalancer } from '../../actions'

export default function LoadBalanceModal({ userId, open, onClose }) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [openSuccessSnackBar, setOpenSuccessSnackBar] = useState(false)
  const { name, user } = useSelector((state: RootState) => state.userLogin)
  const updateDataTable = () => {
    onClose(false)
    setOpenSuccessSnackBar(true)
  }
  const handleLoadBalancer = (event, userId: any) => {
    const obj = { message: name + ' invoked load balancer', userId: user }
    dispatch(runLoadBalancer({ payload: obj }))
    setTimeout(updateDataTable, 500)
  }

  return (
    <Box className={`${classes.mt} , ${classes.mb}`}>
      {openSuccessSnackBar && <SuccessSnackBar message="Request submitted to Load Balancer job" />}
      <Dialog fullWidth maxWidth="sm" id="hello" className={classes.dialogHeight} open={open} onClose={onClose}>
        <DialogTitle className={classes.dialogTitle}>Request Load Balancer run</DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText className={classes.dialogContent}>
            You are about to Request the Load balancer to Run, Click Yes to Continue or No to Cancel.
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.buttonActions}>
          <Button
            className={`${classes.btn} ${classes.buttonMargin}`}
            onClick={(event) => handleLoadBalancer(event, userId)}
            endIcon={<CheckIcon />}
          >
            Yes
          </Button>
          <Button onClick={onClose} variant="outlined" className={classes.buttonMargin} endIcon={<ClearIcon />}>
            No
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}
